import { createContext, useContext, useState } from "react";

const StockContext = createContext();

export const useStockContext = () => useContext(StockContext);

export const StockContextProvider = ({ children }) => {
  const [selectedData, setSelectedData] = useState({
    ledger: "",
    billNo: "",
    entryNo: "",
    openingDate: null,
    item: "",
    code: "",
    ledgerName: "",
    itemName: "",
  });

  const [stockTableData, setStockTabledata] = useState([
    {
      id: Date.now().toString(),
      item: "",
      code: "",
      gwt: "",
      dswt: "",
      nwt: "",
      rate: "",
      netWithWastage: "",
      amount: "",
      netAmount: "",
      itemName: "",
    },
  ]);

  const onStockTableDataChange = (rowNewData) => {
    // Check if it's a new row
    if (rowNewData?.new) {
      setStockTabledata([...stockTableData, { ...rowNewData }]);
      return;
    }

    const rowIndex = stockTableData.findIndex(
      (rowData) => rowData?.id === rowNewData?.id
    );

    // If the row is not found, add it
    if (rowIndex === -1) {
      setStockTabledata([...stockTableData, { ...rowNewData }]);
      return;
    }

    // If the row is marked for deletion, remove it
    if (rowNewData?.delete) {
      const newData = [...stockTableData];
      newData.splice(rowIndex, 1);
      setStockTabledata(newData);
      return;
    }
    if (rowNewData?.clearContent) {
      setStockTabledata({
        id: Date.now().toString(),
        item: "",
        code: "",
        gwt: "",
        dswt: "",
        nwt: "",
        rate: "",
        netWithWastage: "",
        amount: "",
        netAmount: "",
      });
    }

    // Update the existing row
    const newData = [...stockTableData];
    newData[rowIndex] = { ...rowNewData };
    setStockTabledata(newData);
  };
  return (
    <StockContext.Provider
      value={{
        stockTableData,
        setStockTabledata,
        selectedData,
        setSelectedData,
        onStockTableDataChange,
      }}
    >
      {children}
    </StockContext.Provider>
  );
};
